import { render, staticRenderFns } from "./EditablePrinciplesTable.vue?vue&type=template&id=493d86fa&scoped=true&"
import script from "./EditablePrinciplesTable.vue?vue&type=script&lang=js&"
export * from "./EditablePrinciplesTable.vue?vue&type=script&lang=js&"
import style0 from "./EditablePrinciplesTable.vue?vue&type=style&index=0&id=493d86fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d86fa",
  null
  
)

export default component.exports